// extracted by mini-css-extract-plugin
export default {"pendingSkeleton":"UserLessons_pendingSkeleton__tCAPF"};